import React, {useEffect, useState} from "react";
import styled, {ThemeProvider} from "styled-components";
import { Desktop, Mobile, inter, primaryPurple, whiteTransparent, primaryPink, secondaryPinkMedium } from "../Theme";
import calenderLogo from "../resources/images/calendar.svg";
import chartLogo from "../resources/images/chart.svg";
import bulbLogo from "../resources/images/bulb.svg";
import scienceLogo from "../resources/images/science.svg";
import logoutLogo from "../resources/images/logout.svg";
import opnijLogo from "../resources/images/logo_white.svg";
import menuBackground from "../resources/images/menuBackgroundSwirl.svg";
import AppStorage, {StorageKey} from "../util/AppStorage";
import {Link, useHistory, useLocation} from "react-router-dom";
import {RoutesWithoutNav} from "../App";
import {UserType} from "../constants/enums";
import {useGlobalState} from "../util/GlobalState";
import {ReactComponent as PremiumIcon} from '../resources/icons/premium.svg';
import {ReactComponent as PupilIcon} from '../resources/icons/pupil_profile.svg';
import {ReactComponent as GradeIcon} from '../resources/icons/grade.svg';
import {ReactComponent as CalendarIcon} from '../resources/icons/calendar.svg';
import {checkRequiredFeatureFlags} from '../util/Helpers';
import {FeatureFlags} from '../constants/featureFlags';
import {useMenuDataContext} from '../contexts/MenuDataContext';
import Api from "../util/Api";
import {SideMenuSelect} from "../components/Select/SideMenuSelect";
import showBasicPopup from "../popups/showBasicPopup";
import {TopMenuSelect} from "../components/Select/TopMenuSelect";
import {isSchoolYearDisabledRoute} from "../util/PathnameHelpers";
import {useDisableMentorSchoolYear} from "../components/hooks/useDisableMentorSchoolYear";

function SideMenu() {
    const {featureFlags, setPupilOptions} = useMenuDataContext();
    const history = useHistory();
    const location = useLocation();
    const [currentLocation, setCurrentLocation] = useState(location.pathname);
    const [isMentorView,] = useGlobalState('isMentorView', false);
    const [isVisible, setVisible] = useState(false);
    const [selectedGrade] = useGlobalState("selectedGrade");
    const disableSchoolYear = useDisableMentorSchoolYear();

    useEffect(() => {
        const userType = AppStorage.get(StorageKey.USER_TYPE);
        const pupilID = AppStorage.get(StorageKey.PUPIL_ID);
        if (userType === UserType.MENTOR && pupilID === null && !location.pathname.startsWith("/mentor") && !isSchoolYearDisabledRoute(location.pathname)) {
            history.push("/mentor/ef-voortgang");
        }
        if (userType === UserType.PUPIL && location.pathname.startsWith("/mentor")) {
            history.push("/ef-voortgang");
        }
    })

    useEffect(() => {
        if (RoutesWithoutNav.includes(location.pathname)) {
            setVisible(false);
        } else {
            setVisible(true);
        }
        setCurrentLocation(location.pathname);
    }, [location.pathname]);

    useEffect(() => {
        if (!AppStorage.get(StorageKey.GRADE_ID)) {
            AppStorage.set(StorageKey.GRADE_ID, selectedGrade)
        }

        if (AppStorage.get(StorageKey.USER_TYPE) !== "PUPIL" && AppStorage.get(StorageKey.GRADE_ID)) {
            getStudentsFromGrade(AppStorage.get(StorageKey.GRADE_ID));
        }
        //eslint-disable-next-line
    }, [selectedGrade]);

    function getStudentsFromGrade(grade) {
        const defaultOption = {
            value: null,
            label: "Alle leerlingen",
            icon: <StyledPupilIcon/>
        };
        setPupilOptions([defaultOption])

        Api.get("/grades/" + grade + "/pupils", (response) => {
            const data = response.data
            const options = [
                defaultOption,
                ...data.map((pupil) => ({
                    value: pupil.id,
                    label: pupil.title,
                    icon: <StyledPupilIcon/>
                }))
            ]
            setPupilOptions(options)
        }, null, null, () => {
            setPupilOptions([defaultOption])
            showBasicPopup("Ophalen van leerlingen  mislukt!", "Er is iets mis gegaan met het ophalen van de leerlingen. Probeer het zometeen nog een keer.", "OK")
        }, {})
    }

    return (
        <ThemeProvider theme={defaultSidebarTheme}>
            <SideMenuWrapper $visible={isVisible}>
                <MenuBackground src={menuBackground}/>
                <MenuLogo src={opnijLogo}/>
                {AppStorage.get(StorageKey.USER_TYPE) !== UserType.PUPIL && (
                    <MentorMenuTitle>Mentor dashboard</MentorMenuTitle>
                )}
                <PupilInfo isMentorView={isMentorView} disableSchoolYear={disableSchoolYear}/>
                <Divider $isBig={true}/>
                {isMentorView ? (
                    <MenuItemList>
                        <MenuItem
                            src={chartLogo}
                            text={"EF in beeld"}
                            isActive={currentLocation.startsWith("/mentor/ef-voortgang")}
                            to={"/mentor/ef-voortgang"}
                            location={location}
                        />
                        <Divider/>
                        <MenuItem
                            src={calenderLogo}
                            text={"Planagenda"}
                            isActive={currentLocation === "/mentor/planagenda"}
                            to={"/mentor/planagenda"}
                            location={location}
                            showPremiumIcon={!checkRequiredFeatureFlags(featureFlags, FeatureFlags.FEATURE_SCHEDULE)}
                        />
                    </MenuItemList>
                ) : (
                    <MenuItemList>
                        <MenuItem
                            src={chartLogo}
                            text={"EF in beeld"}
                            isActive={currentLocation === "/" || currentLocation.includes("/plan-van-aanpak") || currentLocation.startsWith("/ef-voortgang")}
                            to={"/ef-voortgang"}
                            location={location}
                        />
                        <MenuItem
                            src={bulbLogo}
                            text={"Executieve Functies"}
                            isActive={currentLocation.includes("/executieve-functies")}
                            to={"/executieve-functies"}
                            location={location}
                        />
                        <Divider/>
                        <MenuItem
                            src={calenderLogo}
                            text={"Planagenda"}
                            isActive={currentLocation === "/planagenda"}
                            to={"/planagenda"}
                            location={location}
                            showPremiumIcon={!checkRequiredFeatureFlags(featureFlags, FeatureFlags.FEATURE_SCHEDULE)}
                        />
                        <MenuItem
                            src={scienceLogo}
                            text={"Toetsweek"}
                            isActive={currentLocation === "/toetsweek"}
                            to={"/toetsweek"}
                            location={location}
                            showPremiumIcon={!checkRequiredFeatureFlags(featureFlags, FeatureFlags.FEATURE_SCHEDULE)}
                        />
                    </MenuItemList>
                )}

                <MenuItemList>
                    <LogOutButton src={logoutLogo} text={"Uitloggen"} to={"/login"} onClick={() => {
                        logoutAndGoToLogin(history)
                    }}/>
                </MenuItemList>
            </SideMenuWrapper>
        </ThemeProvider>
    )
}

export function loginAndContinueToNextScreen(data, history) {
    AppStorage.set(StorageKey.API_ACCESS_TOKEN, data.accessToken)
    AppStorage.set(StorageKey.USER_ID, data.id)
    AppStorage.set(StorageKey.FINISHED_ONBOARDING, data.hasFinishedOnboarding)
    AppStorage.set(StorageKey.USER_TYPE, data.type)
    if (data.type === UserType.PUPIL) {
        //login in as pupil
        AppStorage.set(StorageKey.PUPIL_ID, data.id)
    }

    const userType = AppStorage.get(StorageKey.USER_TYPE)
    if (userType === UserType.PUPIL) {
        history.replace("/ef-voortgang");
    } else if (userType === UserType.MENTOR) {
        history.replace("/mentor/ef-voortgang");
    }
}

export function logoutAndGoToLogin(history) {
    AppStorage.remove(StorageKey.USER_ID)
    AppStorage.remove(StorageKey.USER_TYPE)
    AppStorage.remove(StorageKey.API_ACCESS_TOKEN)
    AppStorage.remove(StorageKey.FINISHED_ONBOARDING)
    AppStorage.remove(StorageKey.PUPIL_ID)
    AppStorage.remove(StorageKey.PUPIL_TITLE)
    AppStorage.remove(StorageKey.GRADE_ID)
    AppStorage.remove(StorageKey.SCHOOL_YEAR_ID)
    history.replace("/login")
}

function PupilInfo({isMentorView, disableSchoolYear}) {
    const {schoolYearOptions, gradeOptions, pupilOptions} = useMenuDataContext();
    const isMentor = AppStorage.get(StorageKey.USER_TYPE) === UserType.MENTOR;

    return (
        <PupilInfoWrapper>
            {isMentor && (
                <PupilInfoBar
                    type={"schoolYear"}
                    isMentorView={isMentorView}
                    options={schoolYearOptions}
                    icon={<StyledCalendarIcon/>}
                    minHeight={"36px"}
                    disableSchoolYear={disableSchoolYear}
                />
            )}
            <PupilInfoBar 
                type={"grade"} 
                isMentorView={isMentorView} 
                options={gradeOptions} 
                icon={<StyledGradeIcon/>} 
                minHeight={"36px"}
            />
            <PupilInfoBar 
                type={"pupil"} 
                isMentorView={isMentorView} 
                options={pupilOptions} 
                icon={<StyledPupilIcon/>} 
                minHeight={"36px"}
            />
        </PupilInfoWrapper>
    )
}

export function PupilInfoBar(props) {
    const {type, options, icon, disableSchoolYear} = props;
    const history = useHistory();
    const {schoolYearsAndGradesData, setGradeOptions} = useMenuDataContext();

    const [, setSelectedSchoolYear] = useGlobalState("selectedSchoolYear")
    const [, setSelectedGrade] = useGlobalState("selectedGrade")
    const [, setSelectedPupil] = useGlobalState("selectedPupil")

    const handleSelectOption = (selectedOption) => {
        switch (type) {
            case "schoolYear": {
                const selectedSchoolYear = schoolYearsAndGradesData.find((sy) => sy.value === selectedOption.value) || schoolYearsAndGradesData[0];
                
                setSelectedSchoolYear(selectedSchoolYear.value);
                AppStorage.set(StorageKey.SCHOOL_YEAR_ID, selectedSchoolYear.value);
                AppStorage.set(StorageKey.GRADE_ID, selectedSchoolYear?.grades?.[0]?.value);
                AppStorage.set(StorageKey.PUPIL_ID, null); // Effect in SideMenu handles redirect when PUPIL_ID is set to null

                const newGradeOptions = selectedSchoolYear?.grades?.map((grade) => ({
                    value: grade.value,
                    label: grade.label,
                    icon: <StyledGradeIcon/>,
                }));
                setGradeOptions(newGradeOptions);

                setSelectedGrade(selectedSchoolYear?.grades?.[0]?.value);

                break;
            }
            case "grade":
                setSelectedGrade(selectedOption.value);
                AppStorage.set(StorageKey.GRADE_ID, selectedOption.value);
                AppStorage.set(StorageKey.PUPIL_ID, null); // Effect in SideMenu handles redirect when PUPIL_ID is set to null
                break;
            case "pupil":
                const newId = selectedOption.value
                const oldId = AppStorage.get(StorageKey.PUPIL_ID)
                const currentPath = history.location.pathname

                // When the new value is the same as the old. It should do nothing
                if (oldId === newId) return;

                setSelectedPupil(newId);
                AppStorage.set(StorageKey.PUPIL_ID, newId)

                if (oldId !== newId) {
                    if (currentPath.includes("ef-voortgang")) history.push("/ef-voortgang");
                }

                if (!oldId || !newId) {
                    if (currentPath.includes("planagenda")) {
                        history.push(newId ? "/planagenda" : "mentor/planagenda");
                    } else if (currentPath.includes("meer")) {
                        history.push(newId ? "/meer" : "mentor/meer");
                    } else {
                        history.push("/ef-voortgang");
                    }
                }

                break;
            default:
                break;
        }
    }

    const getValue = () => {
        if (options) {
            if (type === "schoolYear") {
                const schoolYearId = AppStorage.get(StorageKey.SCHOOL_YEAR_ID)
                return {"value": schoolYearId, "label": options.find(item => item.value === schoolYearId)?.label, "icon": <StyledCalendarIcon/>}
            }

            if (type === "grade") {
                const grade = AppStorage.get(StorageKey.GRADE_ID)
                return {"value": grade, "label": options.find(item => item.value === grade)?.label, "icon": <StyledGradeIcon/>}
            }

            if (type === "pupil") {
                const pupil = AppStorage.get(StorageKey.PUPIL_ID)
                return {"value": pupil, "label": options.find(item => item.value === pupil)?.label, "icon": <StyledPupilIcon/>}
            }
        }
    }

    const disabled = AppStorage.get(StorageKey.USER_TYPE) === UserType.PUPIL || (type === "schoolYear" && disableSchoolYear);

    return (
        <>
            <Desktop>
                <SideMenuSelect
                    value={getValue()}
                    placeholder={icon}
                    disabled={disabled}
                    options={options}
                    onChange={(selectedOption) => handleSelectOption(selectedOption)}
                />
            </Desktop>

            <Mobile>
                <TopMenuSelect
                    value={getValue()}
                    placeholder={icon}
                    disabled={disabled}
                    options={options}
                    onChange={(selectedOption) => handleSelectOption(selectedOption)}
                />
            </Mobile>
        </>

    )
}

function MenuItem({showPremiumIcon, ...props}) {
    return (
        <MenuItemWrapper to={props.to} $isActive={props.isActive}>
            <MenuItemLogo src={props.src}/>
            <MenuItemTextWrapper>
                <MenuItemText> {props.text}</MenuItemText>
                {showPremiumIcon && <StyledPremiumIcon/>}
            </MenuItemTextWrapper>
        </MenuItemWrapper>
    );
}

function LogOutButton(props) {
    return (
        <LogOutButtonWrapper onClick={props.onClick}>
            <MenuItemLogo src={props.src}/>
            <MenuItemText> {props.text}</MenuItemText>
        </LogOutButtonWrapper>
    );
}

const defaultSidebarTheme = {
    outerWidth: "254px",
    innerWidth: "224px"
}

const SideMenuWrapper = styled.div`
    background: ${primaryPurple};
    width: ${({theme}) => theme.outerWidth};
    height: 100%;
    display: ${props => props.$visible ? "flex" : "none"};
    flex-direction: column;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 53px;
    flex-shrink: 0;
    padding-bottom: 39px;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;

    div:last-of-type {
        margin-top: auto;
    }
`;


const MenuItemList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    z-index: 10;
`;

const MenuLogo = styled.img`
    height: 62px;
    width: 180px;
    color: white;
    margin-bottom: 30px;
`;

const MenuBackground = styled.img`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    width: 100%;
    height: 292px;
    object-fit: cover;
    z-index: 1;
    pointer-events: none;
    color: white;
`;

const MentorMenuTitle = styled.h2`
    font-family: inter;
    font-size: 21px;
    color: white;
    text-align: center;
    margin: 20px 0;
`;

const Divider = styled.hr`
    width: 100%;
    border-color: ${whiteTransparent};
    margin: ${props => props.$isBig ? "22px 0" : "12px 0"};
`;

const PupilInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 20px;
`;

const MenuItemWrapper = styled(Link)`
    text-decoration: none;
    background: ${props => props.$isActive ? primaryPink : undefined};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${props => props.$backToMentorSchedule ? "10px" : "20px"};
    min-height: 42px;
    height: auto;
    width: ${({theme}) => theme.innerWidth};
    padding-left: 12px;
    padding-right: 13px;
    padding-bottom: ${props => props.$paddingBottom};
    text-overflow: ellipsis;

    &:focus-visible {
        outline-offset: 0;
        outline-style: solid;
        outline-width: 2px;
        outline-color: white;
    }
`;

const LogOutButtonWrapper = styled.button`
    background: none;
    border: none;
    text-decoration: none;
    background: ${props => props.$isActive ? primaryPink : undefined};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    height: 42px;
    width: ${({theme}) => theme.innerWidth};
    padding-left: 13px;
    padding-right: 13px;
    cursor: pointer;

    &:focus-visible {
        outline-offset: 0;
        outline-style: solid;
        outline-width: 2px;
        outline-color: white;
    }
`;

const MenuItemLogo = styled.img`
    color: white;
    display: block;
    height: ${props => props.$size ? props.$size : "24px"};
    width: ${props => props.$size ? props.$size : "24px"};
`;

const MenuItemTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const MenuItemText = styled.h1`
    color: white;
    font-family: ${inter};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
`;

const StyledPremiumIcon = styled(PremiumIcon)`
    width: 24px;
    height: 24px;
    display: block;
    flex-shrink: 0;
    color: ${secondaryPinkMedium};
`;

export const StyledPupilIcon = styled(PupilIcon)`
    width: 20px;
    height: 20px;
    display: block;
    flex-shrink: 0;
    color: white;
`;

export const StyledGradeIcon = styled(GradeIcon)`
    width: 20px;
    height: 20px;
    display: block;
    flex-shrink: 0;
    color: white;
`;

export const StyledCalendarIcon = styled(CalendarIcon)`
    width: 20px;
    height: 20px;
    display: block;
    flex-shrink: 0;
    color: white;
`;

export default SideMenu;